/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const NewsPageFigure = styled.figure`
  height: 150px;

  @media (min-width: ${fullConfig.theme.screens.md}) {
    min-height: 280px;
  }
`;

const ReadMoreLink = styled.a``;

export { NewsPageFigure, ReadMoreLink };
